module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-search flex-box"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "iconfont",
    class: [_vm.isNew ? 'isnew ' + _vm.icon : _vm.icon]
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-search-input flex-box"
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo"
  }), _vm._v(" "), _c('p', [_vm._v("点击搜索模特、艺人的名字、经历...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1382d2b9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 218
// module chunks = 49